export const CONTENT_ASSET_URL_FIELDS = [
    { idField: 'imageAttachmentId', urlField: 'imageUrl', ratioField: 'imageRatio' },
    { idField: 'heroImageAttachmentId', urlField: 'heroImageUrl' },
    { idField: 'videoAttachmentId', urlField: 'videoUrl' },
];
export const CONTENT_MEDIA_ITEMS_FIELD = 'mediaItems';
export const CONTENT_ASSET_URL_FIELD_NAMES = CONTENT_ASSET_URL_FIELDS.map(f => f.urlField);
export const CONTENT_ASSET_DERIVED_FIELD_NAMES = CONTENT_ASSET_URL_FIELDS.flatMap(f => (f.ratioField ? [f.urlField, f.ratioField] : [f.urlField]));
export const CONTENT_MEDIA_ORIGIN_FIELD = 'mediaOrigin';
export function isUserMediaContent(content) {
    return content?.[CONTENT_MEDIA_ORIGIN_FIELD] === 'user';
}
export const CONTENT_MEDIA_FIELD_NAMES = [
    ...CONTENT_ASSET_URL_FIELDS.map(f => f.idField),
    CONTENT_MEDIA_ITEMS_FIELD,
    'videoStatus',
    ...CONTENT_ASSET_DERIVED_FIELD_NAMES,
];
export function contentMediaAttachmentIds(content) {
    if (!content)
        return [];
    if (typeof content.videoAttachmentId === 'string')
        return [content.videoAttachmentId];
    const items = content[CONTENT_MEDIA_ITEMS_FIELD];
    if (Array.isArray(items) && items.length > 0) {
        return items
            .map(item => item?.attachmentId)
            .filter((id) => typeof id === 'string');
    }
    if (typeof content.imageAttachmentId === 'string')
        return [content.imageAttachmentId];
    return [];
}
export const BYO_VIDEO_MIME_TYPES = ['video/mp4', 'video/quicktime'];
export const BYO_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const BYO_MAX_CAROUSEL_ITEMS = 10;
export const BYO_MAX_VIDEO_UPLOAD_BYTES = 150 * 1024 * 1024;
export const BYO_MAX_IMAGE_UPLOAD_BYTES = 50 * 1024 * 1024;
export const MAX_INTENT_INGREDIENTS = 6;
//# sourceMappingURL=content-assets.js.map